import {
  AdditionalMailingType,
  AdditionalMailingAudience,
} from "src/store/additionalMailing/types";
import {
  ADDITIONAL_MAILING_TYPE_LABEL,
  ADDITIONAL_MAILING_AUDIENCE_LABEL,
} from "../labels/additionalMailingLabel";

export const ADDITIONAL_MAILING_TYPE_OPTIONS: {
  label: string;
  value: AdditionalMailingType;
}[] = [
  {
    label: ADDITIONAL_MAILING_TYPE_LABEL.vote_reminder,
    value: "vote_reminder",
  },
  {
    label: "Other (Informational)",
    value: "informational",
  },
];

export const ADDITIONAL_MAILING_AUDIENCE_OPTIONS: {
  label: string;
  value: AdditionalMailingAudience;
}[] = [
  {
    label: ADDITIONAL_MAILING_AUDIENCE_LABEL.all_shareholders,
    value: "all_shareholders",
  },
  {
    label: ADDITIONAL_MAILING_AUDIENCE_LABEL.not_voted_shareholders,
    value: "not_voted_shareholders",
  },
];
